import {
    useEffect,
} from 'react';

import {
    REDIRECT_DELAY_MS,
} from '../constants';

export function useDelayedRedirect(url: string | null): void {
    useEffect(() => {
        if (!url) {
            return;
        }

        const timeoutId = setTimeout(() => {
            window.location.replace(url);
        }, REDIRECT_DELAY_MS);

        return () => clearTimeout(timeoutId);
    }, [url, REDIRECT_DELAY_MS]);
}
